<template>
  <div>
    <div
      :style="{
        height: `${config.height}px`,
        'border-radius': `${config.radius_top}px ${config.radius_top}px ${config.radius_bottom}px ${config.radius_bottom}px`,
        background: `${config.color}`,
        margin: `0 ${config.margin_num}px`,
      }"
    ></div>
  </div>
</template>

<script>
export default {
  name: "tms-split-line",
  props: ["config"],

  data() {
    return {};
  },

  components: {},
  mounted() {},
  methods: {},
};
</script>
